// Chapter order: the story is told in sequence, so only the next unseen chapter (and any already seen) can be opened.

// Index of the first chapter not seen yet, or -1 once every one has been seen.
export function nextChapter(count, visited) {
  for (let i = 0; i < count; i++) if (!visited.has(i)) return i;
  return -1;
}

export function isUnlocked(i, visited, count) {
  return visited.has(i) || i === nextChapter(count, visited);
}
